import type { ReactNode } from "react";
import { AuthContext, useAuthState } from "../../hooks/use-auth";

interface AuthProviderProps {
	children: ReactNode;
}

export default function AuthProvider({ children }: AuthProviderProps) {
	const authValue = useAuthState();

	return <AuthContext.Provider value={authValue}>{children}</AuthContext.Provider>;
}
